// import leaflet from 'leaflet'
import on from '../util/Elements/on'

export default function (Site, $) {
  Site.widget('contact-map', {
    _create () {
      // this.contactMap()
    },

    _transitionIn () {
      this.contactMap()
    },

    _destroy () {
      mymap.remove()
    },

    contactMap () {
      const lat = parseFloat(this.element[0].dataset.lat)
      const lon = parseFloat(this.element[0].dataset.lon)
      const pin =this.element[0].dataset.pin

    	const mymap = L.map('stclares-location', {
    		zoomControl:false,
        dragging: false,
        minZoom: 16,
        maxZoom: 16

    	}).setView([lat,lon], 16);
    	
    	L.tileLayer('https://api.mapbox.com/styles/v1/adamed/cjtoywjfk5ex71fp0ze7fppe6/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWRhbWVkIiwiYSI6ImNqcWx4dDJxdTBwYjk0MnAybG9rOGt2dzEifQ.Y91ndkDlyV4DFRTRTBmE-A', {
			attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
			maxZoom: 20,
			id: 'mapbox.streets',
			accessToken: 'pk.eyJ1IjoiYWRhbWVkIiwiYSI6ImNqdG93dTM4ZDBib2I0OWxhczV6Ymx3dTcifQ.nuEHyhLCOB28VFzk9E9DwA'
		}).addTo(mymap);

    	const redIcon = L.icon({
			iconUrl: pin,

			iconSize:     [30, 48], // size of the icon
			iconAnchor:   [15, 48], // point of the icon which will correspond to marker's location
		});

		L.marker([lat,lon], {icon: redIcon}).addTo(mymap);
    }
  })
}